import styled from 'styled-components';

export const UserCategoryHubItem = styled.div`
    width: 100%;
    background-color: var(--white);
    padding: 14px 12px 12px 12px;
    border-radius: inherit;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    height: 100%;

    img {
        width: 62px;
    }
`;

export const UserCategoryHubItemHeader = styled.div`
    width: 100%;
    color: #88A8A4;
    font-family: var(--font-bold);
    font-size: 0.875rem;
    text-align: center;
    margin-bottom: 6px;
`;

export const UserCategoryHubItemProgress = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    gap: 5px;
    margin-top: auto;
`;

export const UserCategoryHubItemProgressInfos = styled.div<{ color: string }>`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: ${props => props.color};
    font-family: var(--font-bold);
    
    p {
        font-family: 'Gilroy-Medium',sans-serif;
        color: #2D473E;
        font-size: 0.875rem;
    }

    span {
        font-size: 0.875rem;
        color: var(--black);
    }
`;

export const UserCategoryHubItemProgressBar = styled.div<{ $progress: number, color: string }>`
    width: 100%;
    position: relative;
    background-color: var(--gray-bg);
    border-radius: 8px;
    height: 12px;
    &:after {
        content: '';
        width: ${({ $progress }) => ($progress + '%')};
        height: 100%;
        background-color: ${({ color }) => color};
        position: absolute;
        top: 0px;
        left: 0px;
        border-radius: inherit;
    }
`;
